import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot, query, where, orderBy } from "firebase/firestore";

export function useCashClosings(env, client, instanceId) {
  const [loadedCashClosings, setLoadedCashClosings] = useState(false);
  const [cashClosings, setCashClosings] = useState(null);

  useEffect(() => {
    setLoadedCashClosings(false);
    if (!client) {
      setLoadedCashClosings(true);
      return () => [];
    }

    let constraints = [];
    if (instanceId) {
      constraints.push(where("instance_id", "==", instanceId));
    }
    constraints.push(orderBy("created_at", "desc"));

    const ref = collection(db, "kiosk", env, "client", client, "cash_closings");
    const q = query(ref, ...constraints);

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCashClosings(data);
      setLoadedCashClosings(true);
    });

    return () => unsub();
  }, [env, client, instanceId]);

  return { loadedCashClosings, cashClosings };
}
